const parseHtml = htmlString => {
  const parser = new DOMParser();
  return parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
};

const defaultFields = {
  title: 'Freestyle Section',
  enableAnchor: false,
  settings: {
    paddingTop: true,
    paddingBottom: true,
    backgroundColor: '#FFFFFF',
    textColor: '#000000',
    overlayColor: '#000000',
    overlayOpacity: 0,
    showOverlay: false,
    backgroundImage: '',
    useBackgroundMobile: false,
    backgroundImageMobile: '',
  },
  containerPage: {
    enableStyle: false,
    background: '#FFFFFF',
  },
};

export const extractContainerFuild = htmlString => {
  const doc = parseHtml(htmlString);
  const result = {
    ...defaultFields,
  };
  const sectionEl = doc.querySelector('[data-section]');
  if (sectionEl) {
    result.title = sectionEl.getAttribute('data-title') || result.title;
    result.enableAnchor = sectionEl.getAttribute('data-enable-anchor') === 'true';
  }
  const cardContainer = doc.querySelector('[data-attribute="card-container"]');
  if (cardContainer) {
    result.settings.backgroundColor = cardContainer.getAttribute('data-background') || '#FFFFFF';
    result.settings.textColor = cardContainer.getAttribute('data-text-color') || '#000000';
    result.settings.paddingTop = cardContainer.getAttribute('data-top-padding') === 'true' ? true : false;
    result.settings.paddingBottom = cardContainer.getAttribute('data-bottom-padding') === 'true' ? true : false;
    result.settings.overlayColor = cardContainer.getAttribute('data-overlay-color') || '#000000';
    result.settings.overlayOpacity = cardContainer.getAttribute('data-overlay-opacity') || 0;
    result.settings.showOverlay = cardContainer.getAttribute('data-show-overlay') === 'true' ? true : false;
    result.settings.backgroundImage = cardContainer.getAttribute('data-background-image') || '';
    result.settings.useBackgroundMobile =
      cardContainer.getAttribute('data-use-background-mobile') === 'true' ? true : false;
    result.settings.backgroundImageMobile = cardContainer.getAttribute('data-background-image-mobile') || '';
  }
  const containerPage = doc.querySelector('[data-attribute="container-page"]');
  if (containerPage) {
    result.containerPage.enableStyle = containerPage.getAttribute('data-enable-style') === 'true';
    result.containerPage.background = containerPage.getAttribute('data-background-container') || '#FFFFFF';
  }
  return {
    result,
    doc,
  };
};
export const updateContainerFuild = (htmlString, updatedData) => {
  const doc = parseHtml(htmlString);
  const container = doc.body.firstElementChild;
  for (const key in updatedData) {
    switch (key) {
      case 'title': {
        const elTitle = container.querySelector('[data-attribute="section-title"]');
        if (elTitle) {
          elTitle.setAttribute('data-title', updatedData[key]);
        }
        break;
      }
      case 'enableAnchor': {
        const elSection = container.querySelector('[data-section]');
        if (elSection) {
          elSection.setAttribute('data-enable-anchor', updatedData[key] ? 'true' : 'false');
        }
        break;
      }
      case 'settings': {
        const cardContainer = container.querySelector('[data-attribute="card-container"]');
        const overlayBgEl = container.querySelector('[data-attribute="overlay-bg"]');

        if (overlayBgEl) {
          overlayBgEl.style.display = updatedData[key]['showOverlay'] ? 'block' : 'none';
        }
        if (cardContainer) {
          cardContainer.setAttribute('data-background-image', updatedData[key]['backgroundImage']);
          cardContainer.style.backgroundImage = updatedData[key]['backgroundImage']
            ? `url(${updatedData[key]['backgroundImage']})`
            : '';
          cardContainer.setAttribute('data-top-padding', updatedData[key]['paddingTop'] ? 'true' : 'false');
          cardContainer.setAttribute('data-bottom-padding', updatedData[key]['paddingBottom'] ? 'true' : 'false');
          cardContainer.setAttribute('data-background', updatedData[key]['backgroundColor']);
          cardContainer.setAttribute('data-text-color', updatedData[key]['textColor']);
          cardContainer.style.backgroundColor = updatedData[key]['backgroundColor'];
          cardContainer.style.color = updatedData[key]['textColor'];
          cardContainer.style.setProperty('--text-color', updatedData[key]['textColor']);

          cardContainer.setAttribute('data-overlay-color', updatedData[key]['overlayColor']);
          cardContainer.setAttribute('data-overlay-opacity', updatedData[key]['overlayOpacity']);
          cardContainer.setAttribute('data-show-overlay', updatedData[key]['showOverlay'] ? 'true' : 'false');
          cardContainer.style.setProperty('--overlay-color', updatedData[key]['overlayColor']);
          cardContainer.style.setProperty('--overlay-opacity', updatedData[key]['overlayOpacity']);

          cardContainer.setAttribute('data-background-image-mobile', updatedData[key]['backgroundImageMobile']);
          cardContainer.style.setProperty(
            '--background-image-mobile',
            updatedData[key]['backgroundImageMobile'] ? `url(${updatedData[key]['backgroundImageMobile']})` : '',
          );
        }
        break;
      }
      case 'containerPage': {
        const containerPage = container.querySelector('[data-attribute="container-page"]');
        if (containerPage) {
          containerPage.setAttribute('data-enable-style', updatedData[key]['enableStyle'] ? 'true' : 'false');
          containerPage.setAttribute('data-background-container', updatedData[key]['background']);
          containerPage.style.backgroundColor = updatedData[key]['enableStyle']
            ? updatedData[key]['background']
            : 'transparent';
        }
        break;
      }
    }
  }
  return container;
};
